import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://eb0b9adc0f723fe8029b76e3355ddfd8@o1147556.ingest.us.sentry.io/4510742227714048",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});